import React, { FC, useMemo } from "react";
import { connect } from "react-redux";

import { ShapePinLegend } from "@mapmycustomers/shared/types/map/PinLegend";
import { EntityTypesSupportedByMapsPage } from "@mapmycustomers/shared/types/map/types";

import useMapView from "@app/component/view/utils/useMapView";
import RefreshPinLegend from "@app/scene/map/components/Legends/components/RefreshPinLegend";
import { getShapeLegends } from "@app/store/pinLegends";
import { RootState } from "@app/store/rootReducer";

export interface RefreshShapePinLegendProps {
  entityType: EntityTypesSupportedByMapsPage;
}

interface Props extends RefreshShapePinLegendProps {
  pinLegends: ShapePinLegend[];
}

const RefreshShapePinLegend: FC<Props> = ({ entityType, pinLegends }) => {
  const {
    viewState: { shapeKey },
  } = useMapView();

  const pinLegend = useMemo(() => {
    if (!shapeKey?.[entityType]) {
      return undefined;
    }
    return pinLegends.find(({ id }) => id === shapeKey[entityType]);
  }, [shapeKey, entityType, pinLegends]);

  return <RefreshPinLegend pinLegend={pinLegend} />;
};

const mapStateToProps = (state: RootState, { entityType }: RefreshShapePinLegendProps) => ({
  pinLegends: getShapeLegends(state)(entityType),
});

export default connect(mapStateToProps)(RefreshShapePinLegend);
